export const backBtnStyle = {
  minHeight: { xs: '20px', sm: '50px' },
  minWidth: { xs: '50%', sm: '30%', md: '20%' },
  color: 'common.white',
  backgroundColor: 'primary.dark',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  margin: { xs: 0, sm: '16px 0 0 8px' },
  opacity: 1,
} as const;
